import store from 'store/storeConfig';

export const getSurveyLocalize = (survey: ISurveyJS, localizeTitle = false) => {
  const { intl } = store.getState();

  const localizeElements = (elements: ISurveyJSElement[]) => {
    return elements.map((element) => {
      return {
        ...element,
        title: element.title ? intl.messages[element.title] || element.title : '',
        description: element.description
          ? intl.messages[element.description] || element.description
          : '',
        placeHolder: element.placeHolder
          ? intl.messages[element.placeHolder] || element.placeHolder
          : '',
        label: element.label ? intl.messages[element.label] || element.label : '',
        minRateDescription: element.minRateDescription
          ? intl.messages[element.minRateDescription] || element.minRateDescription
          : '',
        maxRateDescription: element.maxRateDescription
          ? intl.messages[element.maxRateDescription] || element.maxRateDescription
          : '',
        choices: element.choices?.map((choice: any) => ({
          value: choice.value || choice,
          text: choice.text
            ? intl.messages[choice.text] || choice.text
            : choice.value || intl.messages[choice],
          score: choice.score
        })),
        min: element.inputType === 'number' ? 0 : undefined
      };
    });
  };

  const localizePages = (pages: ISurveyJSPage[]) =>
    pages.map((page) => ({
      ...page,
      title: page.title ? intl.messages[page.title] || page.title : '',
      description: page.description ? intl.messages[page.description] || page.description : '',
      elements: page.elements ? localizeElements(page.elements) : undefined
    }));

  return {
    showProgressBar: 'top',
    ...survey,
    title: localizeTitle ? intl.messages[survey.title] || survey.title : '',
    description: survey?.description ? intl.messages[survey.description] || survey.description : '',
    elements: survey?.elements && localizeElements(survey.elements),
    pages: survey?.pages && localizePages(survey.pages),
    triggers: survey?.triggers ? JSON.parse(survey?.triggers) : null
  };
};
